import FormattedMessage from 'I18n/components/FormattedMessage';
import { CONTACT_TYPE_ID, COMPANY_TYPE_ID, DEAL_TYPE_ID, TICKET_TYPE_ID, PARTNER_CLIENT_TYPE_ID, PROJECT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import I18n from 'I18n';
import { PRIMARY_STATE, SECONDARY_STATE } from '../../../types/ChickletHoverStates';
import { jsx as _jsx } from "react/jsx-runtime";
const PRIMARY_BUTTON_KEYS = {
  [PRIMARY_STATE]: 'cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.primary',
  [SECONDARY_STATE]: 'cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.secondary'
};
const PRIMARY_BUTTON_SELENIUM_TAGS = {
  [PRIMARY_STATE]: 'chicklet-demote-btn',
  [SECONDARY_STATE]: 'chicklet-promote-btn'
};
const PRIMARY_BUTTON_TEST_IDS = {
  [PRIMARY_STATE]: 'chicklet-demote-btn',
  [SECONDARY_STATE]: 'chicklet-promote-btn'
};
export const checkPairingForPrimaryOption = (fromObjectTypeId, toObjectTypeId) => {
  const fromTypeCouldWork = [CONTACT_TYPE_ID, DEAL_TYPE_ID, TICKET_TYPE_ID, PARTNER_CLIENT_TYPE_ID, PROJECT_TYPE_ID].includes(fromObjectTypeId);
  const toTypeCouldWork = [COMPANY_TYPE_ID].includes(toObjectTypeId);
  return fromTypeCouldWork && toTypeCouldWork;
};
export const getPreviewDefaultActionsData = (args, buttonOverrides) => {
  const {
    canView,
    onPreview
  } = args;
  return Object.assign({
    dataSeleniumTest: 'preview-header--preview-button',
    dataTestId: 'preview-header--preview-button',
    disabled: !canView,
    disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardAssociatedObjects.chicklet.ChickletPreviewButton.noViewAccess"
    }),
    label: I18n.text('cardAssociatedObjects.chicklet.ChickletPreviewButton.preview'),
    onClick: () => onPreview({
      objectTypeId: args.toObjectTypeId,
      objectId: args.objectId
    })
  }, buttonOverrides);
};
export const getPrimaryDefaultActionsData = (args, buttonOverrides) => {
  const {
    fromObjectTypeId,
    toObjectTypeId
  } = args;
  const hidePrimaryOption = fromObjectTypeId === toObjectTypeId || !checkPairingForPrimaryOption(fromObjectTypeId, toObjectTypeId);
  const {
    currentState,
    handleOpenPrimaryModal
  } = args;
  return hidePrimaryOption ? undefined : Object.assign({
    dataSeleniumTest: PRIMARY_BUTTON_SELENIUM_TAGS[currentState],
    dataTestId: PRIMARY_BUTTON_TEST_IDS[currentState],
    label: PRIMARY_BUTTON_KEYS[currentState] && I18n.text(PRIMARY_BUTTON_KEYS[currentState]),
    onClick: handleOpenPrimaryModal
  }, buttonOverrides);
};
export const getEditDefaultActionsData = (args, buttonOverrides) => {
  const {
    handleOpenEditAssociationModal
  } = args;
  return Object.assign({
    dataSeleniumTest: 'chicklet-edit-btn',
    dataTestId: 'chicklet-edit-btn',
    label: I18n.text('cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.edit'),
    onClick: handleOpenEditAssociationModal
  }, buttonOverrides);
};
export const getRemoveDefaultActionsData = (args, buttonOverrides) => {
  const {
    handleOpenRemoveAssociationModal
  } = args;
  return Object.assign({
    dataSeleniumTest: 'chicklet-remove-btn',
    dataTestId: 'chicklet-remove-btn',
    label: I18n.text('cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.removeAssociation'),
    onClick: handleOpenRemoveAssociationModal
  }, buttonOverrides);
};
export const getDefaultChickletHoverActions = args => {
  return {
    PrimaryAction: getPreviewDefaultActionsData(args),
    SecondaryActions: [getPrimaryDefaultActionsData(args), getEditDefaultActionsData(args), getRemoveDefaultActionsData(args)]
  };
};